// import Link from 'next/link';
import React, {useState} from 'react'
import TagList from "./tag-list";
import TagDetail from "./tag-detail";
import {Link} from "react-router-dom";

const TagDashboard = () => {
    const [selectedTag, setSelectedTag] = useState(null);
    const [selectedTagRemoved, setSelectedTagRemoved] = useState(false);

    return (
        <>

            <div className="page-container dashboard-container">
                <div className="items-center justify-start w-1/3 p-8 mb-28">
                    <div className="flex justify-between mb-6">
                        <div className="text-xl">
                            Tags
                        </div>

                        <div className="float-right">
                            <a href="/tags/add-tags" className="button-medium">
                                <span>Add New Tags</span>
                            </a>
                        </div>
                    </div>

                    <TagList
                        setSelectedTagRemoved={setSelectedTagRemoved}
                        selectedTagRemoved={selectedTagRemoved}
                        selectedTag={selectedTag}
                        setSelectedTag={setSelectedTag}/>
                </div>

                <div className="items-center justify-start w-2/3 pb-16 mr-8 my-8">
                    <TagDetail
                        setSelectedTagRemoved={setSelectedTagRemoved}
                        selectedTag={selectedTag}
                        setSelectedTag={setSelectedTag}/>
                </div>
            </div>

        </>
    )
}

export default TagDashboard
